export const convertToMapValue = (normalText) =>
    String(normalText)
        ?.trim()
        ?.toLowerCase()
        ?.replace(/[^0-9a-z]/gi, "");

// Updated labelMapping with litigation backend keys
export const labelMapping = {
    // Litigation backend keys
    lan_number: "LAN Number",
    lrn_status: "LRN Status",
    lrn_date: "LRN Date",
    customer_name: "Customer Name",
    address1: "Address 1",
    address2: "Address 2",
    address3: "Address 3",
    address4: "Address 4",
    email: "Email",
    customer_mobile_number: "Customer Mobile Number",
    npa_date: "NPA Date",
    loan_amount: "Loan Amount",
    disbursal_date: "Disbursal Date",
    product_name: "Product Name",
    claim_amount: "Claim Amount",
    arbitrator_name: "Arbitrator Name",
    award_date: "Award Date",
    roi_amount: "ROI Amount",
    cost_levied: "Cost Levied",
    outstanding_date_as_on: "Outstanding Date As On",
    city: "City",
    state: "State",
    zip_code: "Zip Code",
    bank_account_no: "Bank Account No",
    pos: "POS",
    tos: "TOS",
    emi_amount: "EMI Amount",
    // New keys 
    branch_email: "Branch Email",
    branch_address: "Branch Address",
    sanction_date: "Sanction Date",
    agreement_date: "Agreement Date",
    application_date: "Application Date",
    incorpration_date: "Incorpration Date",
    product_group: "Product Group",
    roi_percentage: "ROI Percentage",
    proprietor_name: "Proprietor Name",
    proprietor_address: "Proprietor Address",
    coborrower1_name: "Coborrower1 Name",
    coborrower1_address: "Coborrower1 Address",
    guarantor_name: "Guarantor Name",
    guarantor_address: "Guarantor Address",
    //Stage of Case : stage_of_case
    stage_of_case: "Stage of Case",
    //Lan Type : lan_type
    lan_type: "Lan Type",
    //Tribunal Type : tribunal_type
    tribunal_type: "Tribunal Type",
    //Demand Notice Date : demand_notice_date
    demand_notice_date: "Demand Notice Date",
    //Evaluated Price : evaluated_price
    evaluated_price: "Evaluated Price",
    //Plot Unit : plot_unit
    plot_unit: "Plot Unit",
    //Description of Security : description_of_security
    description_of_security: "Description of Security",
    //Type of Security : type_of_security
    type_of_security: "Type of Security",
    //Asset Type : asset_type
    asset_type: "Asset Type",
    //Borrower Type: borrower_type
    borrower_type: "Borrower Type",
    //Branch Name : branch_name
    branch_name: "Branch Name",
    //Next Hearing Date : next_hearing_date
    next_hearing_date: "Next Hearing Date",
    //Case Number : case_no
    case_no: "Case Number",
    //Case Status : case_status:
    case_status: "Case Status",
    //Comment1 : comment1
    comment1: "Comment1",
    //Invoice Number : invoice_no
    invoice_no: "Invoice Number",
    //Invoice Amount : invoice_amount
    invoice_amount: "Invoice Amount",
    //Invoice Date : invoice_date
    invoice_date: "Invoice Date",

};


export function convertToMapping(columnObj) {
    if (!columnObj) return {};
    const newObj = {};
    for (const key in columnObj) {
        newObj[key] = {
            slug: convertToMapValue(columnObj?.[key]),
            column: columnObj?.[key],
        };
    }
    return { ...newObj };
}

export function convertToKeyColumn(mapping) {
    if (!mapping) return {};
    const newObj = {};
    for (const key in mapping) {
        newObj[key] = mapping?.[key]?.column;
    }
    return { ...newObj };
}

export function convertToKeyMapping(mapping) {
    if (!mapping) return {};
    const newObj = {};
    for (const key in mapping) {
        newObj[key] = !!mapping?.[key]?.slug ? [mapping?.[key]?.slug] : [];
    }
    return { ...newObj };
}

// Create litigation-specific mapping for automatic matching
export const litigationMapping = {
    lan_number: ["lan_number", "lannumber", "loan_account_number", "loan_account_no", "account_number"],
    lrn_status: ["lrn_status", "lrnstatus", "lrn", "status"],
    lrn_date: ["lrn_date", "lrndate", "lrn_dt"],
    customer_name: ["customer_name", "customername", "name", "client_name", "borrower_name"],
    address1: ["address1", "address_1", "address", "customer_address", "primary_address"],
    address2: ["address2", "address_2", "secondary_address"],
    address3: ["address3", "address_3"],
    address4: ["address4", "address_4"],
    email: ["email", "email_id", "customer_email", "email_address"],
    customer_mobile_number: ["customer_mobile_number", "mobile", "mobile_number", "phone", "contact_number"],
    npa_date: ["npa_date", "npadate", "npa_dt", "npa"],
    loan_amount: ["loan_amount", "loanamount", "principal_amount", "sanctioned_amount"],
    disbursal_date: ["disbursal_date", "disbursaldate", "disbursal_dt", "disbursement_date"],
    product_name: ["product_name", "productname", "product", "scheme"],
    claim_amount: ["claim_amount", "claimamount", "claim"],
    arbitrator_name: ["arbitrator_name", "arbitratorname", "arbitrator"],
    award_date: ["award_date", "awarddate", "award_dt"],
    roi_amount: ["roi_amount", "roiamount", "roi", "interest_amount"],
    cost_levied: ["cost_levied", "costlevied", "cost", "charges"],
    outstanding_date_as_on: ["outstanding_date_as_on", "outstanding_date", "as_on_date"],
    city: ["city", "customer_city"],
    state: ["state", "customer_state"],
    zip_code: ["zip_code", "zipcode", "pincode", "postal_code"],
    bank_account_no: ["bank_account_no", "account_no", "bank_account", "account_number"],
    pos: ["pos", "principal_outstanding", "outstanding"],
    tos: ["tos", "total_outstanding"],
    emi_amount: ["emi_amount", "emiamount", "emi", "installment_amount"],
    stage_of_case: ["stage_of_case", "stageofcase", "case_stage", "current_stage"],
    lan_type: ["lan_type", "lantype", "loan_type", "account_type"],
    tribunal_type: ["tribunal_type", "tribunaltype", "tribunal", "court_type"],
    demand_notice_date: ["demand_notice_date", "demandnoticedate", "demand_notice", "notice_date"],
    evaluated_price: ["evaluated_price", "evaluatedprice", "valuation_price", "valuation_amount"],
    plot_unit: ["plot_unit", "plotunit", "plot_size", "unit_size"],
    description_of_security: ["description_of_security", "descriptionofsecurity", "security_description", "security_details"],
    type_of_security: ["type_of_security", "typeofsecurity", "security_type", "security"],
    asset_type: ["asset_type", "assettype", "asset_class", "asset"],
    borrower_type: ["borrower_type", "borrowertype", "customer_type", "client_type"],
    branch_name: ["branch_name", "branchname", "branch"],
    next_hearing_date: ["next_hearing_date", "nexthearingdate", "hearing_date", "next_hearing"],
    case_no: ["case_no", "caseno", "case_number", "caseid"],
    case_status: ["case_status", "case_status", "status", "casecurrentstatus"],
    invoice_no: ["invoice_no", "invoiceno", "invoice_number", "invoiceid"],
    invoice_amount: ["invoice_amount", "invoiceamount", "amount", "invoice_value"],
    invoice_date: ["invoice_date", "invoicedate", "invoice_dt"],
};